<template>
    <div class="page-content egl-dialog-elm original-dialog">
      <h1 class="page-title">{{$locale("sideMenu.shop.othersGroupSetting")}}</h1>
      <!-- searchArea -->
      <el-row :gutter="10" class="search-area">
        <el-col :span="14">
          <el-row :gutter="10">
            <el-col :span="10">
              <el-input
                :placeholder="$locale('form.plsEnterYourName')"
                v-model="curValue"
                @keyup.enter.native="getList()"
              >
                <i slot="suffix" class="el-input__icon el-icon-search" @click="getList()"></i>
              </el-input>
            </el-col>
            <el-col :span="4">
              <el-button class="egl-btn-yellow" @click="getList()">{{$locale("global.search")}}</el-button>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="10" class="ta-r">
          <el-button class="egl-btn-gray" disabled v-if="!unApprove">{{ $locale("global.approve") }}</el-button>
          <el-button class="egl-btn-yellow" @click="approve_fn" v-else>{{ $locale("global.approve") }}</el-button>
          <el-button @click="isDialogShow" class="egl-btn-yellow">{{ $locale("global.create") }}</el-button>
        </el-col>
      </el-row>
      <!-- table -->
      <div class="egl-table list-table">
        <el-table
          :data="tableData"
          stripe
          @filter-change="(column) => getList(column.effective)"
        >
          <el-table-column :label="$locale('global.change')" width="50" align="center" prop="isApprove">
            <template slot-scope="scope">
              <i class="el-icon-circle-check change" v-show="!scope.row.isApprove"></i>
            </template>
          </el-table-column>
          <el-table-column
            v-for="(item, idx) in labelData"
            :key="idx"
            :label="item.label"
            :prop="item.prop"
            :column-key="item.filterName && item.filterName"
            :filters="item.filters && item.filters"
            :filtered-value="[true, false]"
            :min-width="item.width"
          />
          <el-table-column
            column-key="effective"
            :label="$locale('global.status')"
            prop="effective"
            min-width="160"
            align="center"
            :filters="[
              {
                text: this.$locale('global.valid'),
                value: true
              },
              {
                text: this.$locale('global.invalid'),
                value: false
              }
            ]"
            :filtered-value="[true, false]"
          >
            <template slot-scope="scope">
              <i :class="scope.row.effective ? 'status-btn' : 'status-btn grey'"></i>
              {{ scope.row.effective ? $locale('global.valid') : $locale('global.invalid') }}
            </template>
          </el-table-column>
          <el-table-column :label="$locale('global.control')" align="center" width="170">
            <template slot-scope="scope">
              <div class="handle">
                <a @click="isDialogShow('detail', scope.row)">{{ $locale("global.detail") }}</a>
                <el-divider direction="vertical"></el-divider>
                <a @click="isDialogShow('update', scope.row)">{{ $locale("global.edit") }}</a>
                <el-divider direction="vertical"></el-divider>
                <a @click="approve_fn('delete', scope.row.name, scope.row.id)">{{ $locale("global.delete") }}</a>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- dialog -->
      <el-dialog
      :visible.sync="isDialogVisible"
      width="980px"
      @close="closeHandler"
      class="egl-dialog"
      :close-on-click-modal="false"
    >
      <div slot="title" class="dialog-title">
        <div class="tipsBox">
          <p>{{$locale('otherGoods.dialogTitle')}}</p>
          <el-tooltip
            :content="$locale('otherGoods.dialogTitle')"
            placement="top"
            ><span class="tipIcon"></span
          ></el-tooltip>
        </div>
      </div>
      <div class="dialog-content">
          <el-form
            label-position="top"
            label-width="40px"
            :model="form"
            class="setForm"
            ref="dialogForm"
            :rules="rules"
            :disabled="!isEdit"
          >
            <div class="tipsBox">
              <div class="form-module-tit">{{ $locale("global.basicInfo") }}</div>
              <el-tooltip :content="$locale('global.basicInfo')" placement="top"
                ><span class="tipIcon"></span
              ></el-tooltip>
            </div>
            <el-form-item :label="$locale('global.name')" prop="name">
              <el-input
                :placeholder="$locale('form.plsEnterYourName')"
                v-model="form.name"
              />
            </el-form-item>
            <el-form-item :label="$locale('otherGoods.itemCode')" prop="goodsCode">
              <el-input
                :placeholder="$locale('otherGoods.plsEnterItemCode')"
                v-model="form.goodsCode"
              />
            </el-form-item>
            <el-form-item :label="$locale('otherGoods.detailedSummary')" prop="comment">
              <el-input
                :placeholder="$locale('otherGoods.plsEnterDetailsDescription')"
                v-model="form.comment"
              />
            </el-form-item>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item :label="$locale('global.unitPrice')" prop="price">
                  <el-input
                    :placeholder="$locale('form.PlsEnterUnitPrice')"
                    v-model.number="form.price"
                    maxlength="10"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$locale('global.quantity')" prop="inventory">
                  <el-input
                    :placeholder="$locale('form.plsEnterQuantity')"
                    v-model="form.inventory"
                    maxlength="10"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$locale('global.unit')" prop="unit">
                  <el-input
                    :placeholder="$locale('form.plsEnterUnit')"
                    v-model="form.unit"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$locale('global.saletaxRate')" prop="taxRate">
                  <TaxSelect
                    v-model="form.taxRate"
                    :placeholder="$locale('form.plsSelectTaxRate')"
                  ></TaxSelect>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="tipsBox">
              <div class="form-module-tit">{{ $locale("global.dispRelatedSettings") }}</div>
              <el-tooltip :content="$locale('global.dispRelatedSettings')" placement="top"
                ><span class="tipIcon"></span
              ></el-tooltip>
            </div>
            <el-row :gutter="10">
              <el-col :span="8">
                <el-form-item :label="$locale('global.status')" prop="effective">
                  <el-select
                    v-model="form.effective"
                  >
                    <el-option
                      :label="$locale('global.valid')"
                      :value="true"
                      :key="true"
                    ></el-option>
                    <el-option
                      :label="$locale('global.invalid')"
                      :value="false"
                      :key="false"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$locale('bookKeeping.journal.dept')+' ('+$locale('setting.pay.accgroup')+')'" class="makeFull">
                  <el-select v-model="form.journalType">
                    <el-option v-for="item in tradeGroupList"
                      :label="item.name"
                      :key="item.id"
                      :value="item.id"
                    />  
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <ApproveField v-if="!form.isApprove" v-model="form.reflectDate" :formData="form" fieldName="reflectDate" />
          </el-form>
      </div>
      <div slot="footer" class="dialog-footer" v-if="dialogType !== 'detail'">
          <el-row type="flex" justify="center">
            <el-col :span="6">
              <el-button
                @click="isDialogShow"
                class="egl-btn-white"
              >
                {{ $locale("global.cancel") }}
              </el-button>
            </el-col>
            <el-col :span="6">
              <el-button
                @click="submitForm('create')"
                class="egl-btn-yellow"
              >
                {{ $locale("global.confirm") }}
              </el-button>
            </el-col>
          </el-row>
      </div>
    </el-dialog>
    </div>
</template>

<script>
import { priceFormat } from "../../utils/common";
import {
  getOtherGoodsListService,
  addOtherGoodsService,
  updateOtherGoodsService,
  deleteOtherGoodsService,
  approveOtherGoodsService,
  OtherGoodsServiceDetail
} from "@/helpers/service/api/otherGoods";
import ApproveField from "@/components/common/ApproveField";
import countDownAlert from "@/utils/countDownAlert";
import TaxSelect from "@/components/common/TaxSelect";
import { positiveNumValidator } from "@/utils/formFieldValidator";
import { getListService } from "@/helpers/service/api/tradeGroup"

export default {
  data() {
    return {
      cinemaId: "",
      brandId: "",
      curValue: "",
      tableData: [],
      tradeGroupList: [],
      isDialogVisible: false,
      labelData: [
        {
          label: this.$locale("global.name"),
          prop: "name",
          width: 300,
        },
        {
          label: this.$locale("otherGoods.itemCode"),
          prop: "goodsCode",
          width: 200,
        },
        {
          label: this.$locale("global.unitPrice"),
          prop: "priceText",
          width: 200,
        },
        {
          label: this.$locale("global.quantity"),
          prop: "inventoryText",
          width: 160,
        },
        {
          label: this.$locale("global.unit"),
          prop: "unit",
          width: 160,
        },
        {
          label: this.$locale("global.saletaxRate"),
          prop: "taxRateText",
          width: 160,
        },
      ],
      dialogType: "create",
      form: {
        id: "",
        name: "",
        goodsCode: "",
        comment: "",
        price: "",
        inventory: "",
        unit: "",
        taxRate: 0.1,
        effective: true,
        journalType: '',
        reflectDate: this.$moment().startOf("day").valueOf(),
      },
      isEdit: true,
      rules: {
        name: [
          {
            required: true,
            message: this.$locale("form.plsEnterYourName"),
            trigger: "blur"
          }
        ],
        price: [
          {
            validator: positiveNumValidator,
            trigger: "blur",
          },
        ],
        inventory: [
          {
            validator: positiveNumValidator,
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    unApprove() {
      return this.tableData.some(item => !item.isApprove);
    }
  },
  async created() {
    this.cinemaId = window.localStorage.getItem("cinemaId");
    this.brandId = window.localStorage.getItem("brandId");
    await this.getList();
    await this.getTradeGroup();
  },
  methods: {
    getTradeGroup() {
      getListService({
        brandId: this.brandId, 
      }).then(res => {
        this.tradeGroupList = res.data
      })
    },

    getList(filterType) {
      getOtherGoodsListService({
        cinemaId: this.cinemaId,
        ...this.curValue ? { name: this.curValue } : {},
        ...filterType && filterType.length === 1 ? { effective: filterType } : {},
        pageSize: 20
      }).then(res => {
        let { data: { data } } = res;
        data.forEach(item => {
          item.taxRateText = item.taxRate < 0 ? this.$locale("global.notApplicable") : item.taxRate === 0 ? this.$locale("global.dutyFree") : item.taxRate * 100 + "%";
          item.priceText = priceFormat(item.price);
          item.inventoryText = priceFormat(item.inventory);
        });
        this.tableData = data;
      });
    },
    showApprove() {
      this.$refs.approve.toggleApprove();
    },
    approve_fn(type, name, id) {
      // let name = '';
      let confirmHtml = "";
      if (type === "delete") {
        confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.delete")} ${name}?</span>`;
      } else {
        confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.approveAll")}</span>`;
      }
      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.confirm"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      })
        .then(() => {
          if (type === "delete") {
            deleteOtherGoodsService({ id }).then(() => {
              this.getList();
            });
          } else {
            approveOtherGoodsService({ cinemaId: this.cinemaId }).then(() => {
              this.getList();
            });
          }
        })
        .catch(() => {});

    },
    isDialogShow(type, data) {
      if (this.$refs.dialogForm) {
        this.$refs.dialogForm.clearValidate();
      }
      if (type && typeof(type) !== "object") {
        this.dialogType = type;
        if (type === "update" || type === "detail") {
          if (data) {
            OtherGoodsServiceDetail({ id: data.id }).then(res => {
              this.form = res.data;
              this.isEdit = type === "detail" ? false : res.data.edit;
            });
          }
        }
      } else {
        this.dialogType = "create";
      }
      this.isDialogVisible = !this.isDialogVisible;
    },
    closeHandler() {
      // this.dialogType = "create";
      this.form = {
        id: "",
        name: "",
        goodsCode: "",
        comment: "",
        price: "",
        inventory: "",
        unit: "",
        taxRate: 0.1,
        effective: true,
        reflectDate: this.$moment().startOf("day").valueOf(),
      };
      this.isEdit = true;
    },
    submitForm() {
      this.$refs["dialogForm"].validate(valid => {
        if (valid) {
          const requestParam = {
            ...this.form,
            // brandId: window.localStorage.getItem("brandId"),
            cinemaId: this.cinemaId,
          };

          const requestScuessFn = (countDownText = "") => {
            this.isDialogShow();
            countDownAlert({
              content: countDownText,
              callback: () => {
                this.getList();
              }
            });
          };

          if (this.dialogType === "create") {
            addOtherGoodsService(requestParam).then(() => {
              requestScuessFn(this.$locale("global.createSuccessfully"));
            });
          } else {
            updateOtherGoodsService(requestParam).then(() => {
              requestScuessFn(this.$locale("global.updateSuccessfully"));
            });
          }
        } else {
          return false;
        }
      });
    },
  },
  components: {
    ApproveField,
    TaxSelect,
  },
};
</script>